import { render, staticRenderFns } from "./speflly.vue?vue&type=template&id=2190b6cb&scoped=true&"
import script from "./speflly.vue?vue&type=script&lang=js&"
export * from "./speflly.vue?vue&type=script&lang=js&"
import style0 from "./speflly.vue?vue&type=style&index=0&id=2190b6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2190b6cb",
  null
  
)

export default component.exports